import { FormControl, FormLabel } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";

const WholeNumberEditor = (props: IFieldEditor) => {
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) : void => {
    props.onValueChange(props.property.Id, event.target.value);
  };

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <FormControl
        type="number"
        step="1"
        value={props.property.PublishedValue ?? ""}
        onChange={handleChange}
      />
    </>
  );
}

export default WholeNumberEditor;